import { render } from "./DashboardEditTable.vue?vue&type=template&id=748ccc2c"
import script from "./DashboardEditTable.vue?vue&type=script&lang=js"
export * from "./DashboardEditTable.vue?vue&type=script&lang=js"

import "./DashboardEditTable.vue?vue&type=style&index=0&id=748ccc2c&lang=css"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__